export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 2_05.ad1b4da6.jpg";